import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-account-star",
  "use": "rt-base-account-star-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol fill=\"#FFC12C\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-account-star\">\n<path d=\"M905.5,364.1l-225-33.2c-6.3,0-11.1-3.2-12.7-7.9l-98.2-203.8c-6.3-12.6-15.8-22.1-28.5-28.4c-31.7-15.8-69.7-3.2-85.6,28.4\n\tl-99.8,202.2c-3.2,3.2-7.9,7.9-12.7,7.9l-225,33.2c-14.3,3.2-26.9,9.5-36.4,19c-23.8,25.3-23.8,66.4,1.6,90.1l160,158\n\tc3.2,3.2,6.3,9.5,4.8,14.2l-38,222.8c-3.2,12.6,0,26.9,6.3,39.5c15.8,31.6,53.9,42.7,85.6,26.9l201.2-106l0,0\n\tc4.8-1.6,11.1-1.6,15.8,0l201.2,105.8c11.1,6.3,25.4,7.9,39.6,6.3c34.9-6.3,58.6-37.9,52.3-72.7l-38-222.8c0-4.7,1.6-11.1,4.8-14.2\n\tl161.6-158c11.1-9.5,17.4-22.1,19-36.3C964.1,400.5,940.4,368.9,905.5,364.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/account-star.svg
// module id = 1240
// module chunks = 91